const SENSOR_CONFIGS = {
  0: "green",
  1: "yellow",
  2: "orange",
  3: "#ed4242",
  4: "brown",
};

export default SENSOR_CONFIGS;
